export default [
    "you died",
    "you died",
    "you died again",
    "you died",
    "you died",
    "pjsalt",
    "you died",
    "you died?",
    "what happened?",
    "you died",
    "press f",
    "you died",
    "ouch",
    "dang it",
    "not like this",
    "you died",
    // "rest in peace",
    // "that's rough buddy",
    // "everyone is dead",
    // "you have died",
    // "game over",
]
